export const getUpdateSingleAccount = async (dataHouse, accountId) => {
  const singleAccountDetails = await dataHouse.find((data) => {
    return data.id === accountId;
  });
  return singleAccountDetails;
};
